import * as React from "react";
import { forwardRef } from "react";
const SvgIconClearField = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={19} height={19} viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g fill="none" fillRule="evenodd"><circle fill="none" cx={9.5} cy={9.5} r={9.5} /><g stroke="#cccccc" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}><path d="m5.188 5.187 8.625 8.625M13.813 5.187l-8.625 8.625" /></g></g></svg>;
const ForwardRef = forwardRef(SvgIconClearField);
export { ForwardRef as ReactComponent };